import { faker } from '@faker-js/faker/locale/es';
import type { Machine, TelemetryPoint } from './types';

export interface TelemetryStore {
  [key: string]: TelemetryPoint[]; // key = `${machineId}:${signal}`
}

const SIGNALS: Record<string, { baseline: number; range: number }> = {
  temp: { baseline: 65, range: 8 },
  vibration: { baseline: 2.4, range: 0.6 },
  flow: { baseline: 12, range: 3 },
  power: { baseline: 18, range: 4 },
};

export function generateTelemetry(machines: Machine[], pointsPerSignal: number = 60): TelemetryStore {
  const store: TelemetryStore = {};
  const now = Date.now();
  for (const m of machines) {
    if (m.status !== 'RUNNING' && m.status !== 'PAUSED') continue;
    for (const [signal, cfg] of Object.entries(SIGNALS)) {
      const key = `${m.id}:${signal}`;
      const arr: TelemetryPoint[] = [];
      let value = cfg.baseline;
      for (let i = pointsPerSignal - 1; i >= 0; i--) {
        value += faker.number.float({ min: -cfg.range / 6, max: cfg.range / 6 });
        value = Math.max(cfg.baseline - cfg.range, Math.min(cfg.baseline + cfg.range, value));
        arr.push({
          timestamp: new Date(now - i * 60_000).toISOString(),
          value: Number(value.toFixed(2)),
        });
      }
      store[key] = arr;
    }
  }
  return store;
}
